import React,
{
    useState
}
from "react";

import EditLinkModal
    from "./EditLinkModal";

import {
    deleteLink,
    updateLink
}
from "../services/shortLinkService";

export default function LinkTable({
    currentUser,
    links,
    refresh,
    onViewStats
}) {

    const [editingLink,
        setEditingLink] =
        useState(null);

    async function handleDelete(
        code
    ) {

        const confirmed =
            window.confirm(
                `Delete "${code}"?`
            );

        if (!confirmed) {
            return;
        }

        try {

            await deleteLink(
                currentUser,
                code
            );

            await refresh();

        }

        catch (error) {

            console.error(error);

            alert(
                "Unable to delete link."
            );

        }

    }

    async function handleToggle(
        link
    ) {

        try {

            await updateLink(
                currentUser,
                link.shortCode,
                {
                    active:
                        !link.active
                }
            );

            await refresh();

        }

        catch (error) {

            console.error(error);

            alert(
                "Unable to update link."
            );

        }

    }

    async function copyLink(
        shortCode
    ) {

        const url =
            `${process.env.REACT_APP_LINK_API}/${shortCode}`;

        try {

            await navigator.clipboard
                .writeText(url);

            alert(
                "Link copied to clipboard."
            );

        }

        catch (error) {

            console.error(error);

        }

    }

    if (
        !links ||
        links.length === 0
    ) {

        return (

            <div className="emptyLinks">

                No links have been created yet.

            </div>

        );

    }

    return (

        <div className="linkTableCard">

            <h2 className = "statsInfo">
                Created Short Links
            </h2>

            <table
                className="linkTable"
            >

                <thead>

                    <tr>

                        <th>
                            Code
                        </th>

                        <th>
                            Title
                        </th>
                        <th>URL</th>
                        <th>
                            Status
                        </th>

                        <th>
                            Clicks
                        </th>

                        <th>
                            Actions
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {
                        links.map(
                            link => (

                                <tr
                                    key={
                                        link.shortCode
                                    }
                                >

                                    <td>

                                        {
                                            link.shortCode
                                        }

                                    </td>
                                    <td>

                                        {
                                            link.title
                                        }

                                    </td>
                                                                            <td>

                                        <a
                                            href={link.shortUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {link.shortUrl}
                                        </a>

                                    </td>
                                    <td>

                                        {
                                            link.active
                                            ?

                                            <span className="activeStatus">
                                                Active
                                            </span>

                                            :

                                            <span className="inactiveStatus">
                                                Disabled
                                            </span>
                                        }

                                    </td>

                                    <td>

                                        {
                                            link.clickCount || 0
                                        }

                                    </td>

                                    <td>

                                        <div className="actionButtons">

                                            <button
                                                onClick={() =>
                                                    copyLink(
                                                        link.shortCode
                                                    )
                                                }
                                            >
                                                Copy
                                            </button>

                                            <button
                                                onClick={() =>
                                                    window.open(
                                                        `${process.env.REACT_APP_LINK_API}/api/links/${link.shortCode}/qr`,
                                                        "_blank"
                                                    )
                                                }
                                            >
                                                QR
                                            </button>

                                            <button
                                                onClick={() =>
                                                    onViewStats(
                                                        link.shortCode
                                                    )
                                                }
                                            >
                                                Stats
                                            </button>

                                            <button
                                                onClick={() =>
                                                    setEditingLink(
                                                        link
                                                    )
                                                }
                                            >
                                                Edit
                                            </button>

                                            <button
                                                onClick={() =>
                                                    handleToggle(
                                                        link
                                                    )
                                                }
                                            >
                                                {
                                                    link.active
                                                    ?
                                                    "Disable"
                                                    :
                                                    "Enable"
                                                }
                                            </button>

                                            <button
                                                className="dangerButton"
                                                onClick={() =>
                                                    handleDelete(
                                                        link.shortCode
                                                    )
                                                }
                                            >
                                                Delete
                                            </button>

                                        </div>

                                    </td>

                                </tr>

                            )
                        )
                    }

                </tbody>

            </table>
            {
                editingLink &&
                (
                    <EditLinkModal
                        currentUser={
                            currentUser
                        }
                        link={
                            editingLink
                        }
                        refresh={
                            refresh
                        }
                        onClose={() =>
                            setEditingLink(null)
                        }
                    />
                )
            }
        </div>

    );

}